import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';
import { CallingMember } from './useMeetingMembers';

interface Props {
    member: CallingMember;
}

const MeetingCallingParticipantRow = ({ member }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex items-center gap-x-3 rounded-sm px-6 py-2 text-base hover:bg-gray-700">
            <ContactAvatar contact={member.contact} size="medium" />
            <div className="flex flex-col truncate">
                <span className="truncate">{member.name}</span>
                <span className="font-bold text-yellow-400">
                    {i18next.t('callcontrol.outgoing_call')}
                </span>
            </div>
        </div>
    );
};

// memo: see MeetingParticipantRow — stable member objects from useMeetingMembers
// let this skip the panel's incidental re-renders.
export default React.memo(MeetingCallingParticipantRow);
